// GenericSelect.tsx
import React from 'react';
import { MenuItem } from '@mui/material';
import { SelectType } from 'src/components-dummy';
import { SelectStyled, SelectWrapperStyled } from './GenericSelect.style';
import { GenericSelectProps } from './types';

const GenericSelect = <T extends string>({
  value,
  onChange,
  options,
  icon,
  placeholder = 'Select...',
  renderOption,
  menuWidth,
}: GenericSelectProps<T>): JSX.Element => {
  const renderValue = (selected: unknown) => {
    if (!selected || selected === '') return placeholder;
    const selectedOption = options.find(opt => opt.value === selected);
    return selectedOption ? selectedOption.label : selected;
  };

  return (
    <SelectWrapperStyled>
      {icon}
      <SelectStyled
        type={SelectType.Primary}
        value={value}
        onChange={onChange}
        renderValue={selected => <>{renderValue(selected)}</>}
        menuWidth={menuWidth}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {renderOption ? renderOption(option) : option.label}
          </MenuItem>
        ))}
      </SelectStyled>
    </SelectWrapperStyled>
  );
};

export default GenericSelect;
